import React from "react";
import "./CommunityProfileComponent"


/**
 * CommunityProfileComponent
 * 
 * Renders the main container for a community profile section.
 * Receives editable and non-editable field elements as props,
 * along with handlers and profile name information.
 * 
 * Props:
 * - communityProfileName: String
 * - formattedCommunityProfileName: String
 * - NonEditableFieldElements: React elements
 * - EditableFieldElements: React elements
 * - handleSubmitCommunityProfile: Function
 */
const CommunityProfileComponent = ({
  communityProfileName,
  formattedCommunityProfileName,
  NonEditableFieldElements,
  EditableFieldElements,
  handleSubmitCommunityProfile,
}) => {
  return (
    <div key={communityProfileName} className="dynamic-form">
      <h1>
        {/* {formattedCommunityProfileName} Profile */}
        {/* Edit icon and popup logic are intentionally omitted for clarity */}
      </h1>
      {/* Non-editable fields can be rendered here if needed */}
      {/* {NonEditableFieldElements} */}
      {EditableFieldElements}
    </div>
  );
};

export default CommunityProfileComponent;


// //CommunityProfileComponent.js

// import React from "react";
// import "./DynamicProfileSeperatePopUpEdit.css";
// import CommunityProfileComponent from "./CommunityProfileComponent";
// import EditableField from "./EditableFields";
// import { useCommunityProfileAPI } from "./useCommunityProfileAPI"; // Import the new hook

// const CommunityProfileMain = ({ user, communityId, onCommunityName }) => {
//   const {
//     formData,
//     setFormData,
//     communityName,
//     isCommunityProfileComplete,
//     json,
//     submitProfile,
//   } = useCommunityProfileAPI(user, communityId, onCommunityName);

//   const handleInputChange = (event, communityProfileName, fieldName) => {
//     const value = event.target.value;
//     setFormData((prevState) => ({
//       ...prevState,
//       data: {
//         ...prevState.data,
//         Profile: {
//           ...(prevState.data.Profile || {}),
//           [fieldName]: value,
//         },
//       },
//     }));
//   };

//   const handleCheckboxChange = (
//     event,
//     communityProfileName,
//     fieldName,
//     option
//   ) => {
//     const newFormData = { ...formData };
//     if (!newFormData.data.Profile) {
//       newFormData.data.Profile = {};
//     }
//     const interests = newFormData.data.Profile[fieldName] || [];
//     if (event.target.checked) {
//       interests.push(option);
//     } else {
//       const index = interests.indexOf(option);
//       if (index !== -1) {
//         interests.splice(index, 1);
//       }
//     }
//     newFormData.data.Profile[fieldName] = interests;
//     setFormData(newFormData);
//   };

//   const renderCommunityProfiles = () => {
//     if (!formData || !formData.schema || !formData.data) return null;
//     const communityProfiles = formData.data;
//     const communityProfilesArray = [];
//     const schema = formData.schema;

//     for (const [communityProfileName, communityProfileSchema] of Object.entries(
//       schema
//     )) {
//       const fields = Object.keys(communityProfileSchema);

//       const FieldElements = (DisableFields) => {
//         return fields.map((fieldName) => {
//           const fieldType = communityProfileSchema[fieldName].type;
//           const fieldEnum = communityProfileSchema[fieldName].enum;
//           const fieldValue = communityProfiles.Profile?.[fieldName] ?? "";
//           const charachterLimit = communityProfileSchema[fieldName].charachterLimit;

//           if (fieldType === "String" && fieldEnum) {
//             const optionElements = fieldEnum.map((option) => (
//               <option key={option} value={option}>
//                 {option}
//               </option>
//             ));
//             return (
//               <div key={fieldName}>
//                 <label htmlFor={fieldName}>{fieldName}</label>
//                 <select
//                   id={fieldName}
//                   name={fieldName}
//                   value={fieldValue}
//                   onChange={(event) =>
//                     handleInputChange(event, communityProfileName, fieldName)
//                   }
//                   disabled={DisableFields}
//                 >
//                   {optionElements}
//                 </select>
//               </div>
//             );
//           } else if (
//             Array.isArray(fieldType) &&
//             fieldType[0].type === "String" &&
//             fieldType[0].htmlref === "checkbox"
//           ) {
//             const optionElements = fieldType[0].enum.map((option, index) => {
//               const checkboxId = `${fieldName}-${index}`;
//               return (
//                 <div key={option} className="dynamic-form">
//                   <input
//                     type="checkbox"
//                     id={checkboxId}
//                     name={fieldName}
//                     value={option}
//                     checked={fieldValue.includes(option)}
//                     onChange={(event) =>
//                       handleCheckboxChange(
//                         event,
//                         communityProfileName,
//                         fieldName,
//                         option
//                       )
//                     }
//                     disabled={DisableFields}
//                   />
//                   <label
//                     id="checkBoxItems"
//                     htmlFor={checkboxId}
//                     className="dynamic-form__checkbox-label"
//                   >
//                     {option}
//                   </label>
//                 </div>
//               );
//             });
//             return (
//               <div key={fieldName} className="dynamic-form-checkboxes">
//                 <label
//                   id="checkBoxLabel"
//                   className="dynamic-form__checkbox-label"
//                 >
//                   {fieldName}
//                 </label>
//                 {optionElements}
//               </div>
//             );
//           } else if (fieldType === "String") {
//             return (
//               <EditableField
//                 fieldName={fieldName}
//                 fieldValue={fieldValue}
//                 charachterLimit={charachterLimit}
//                 handleSave={handleInputChange}
//                 communityProfileName={communityProfileName}
//                 DisableFields={DisableFields}
//               />
//             );
//           } else {
//             return null;
//           }
//         });
//       };

//       const EditableFieldElements = FieldElements(false);
//       const NonEditableFieldElements = FieldElements(true);

//       communityProfilesArray.push(
//         <CommunityProfileComponent
//           key={communityProfileName}
//           communityProfileName={communityName}
//           formattedCommunityProfileName={communityName}
//           NonEditableFieldElements={NonEditableFieldElements}
//           EditableFieldElements={EditableFieldElements}
//           handleSubmitCommunityProfile={submitProfile}
//         />
//       );
//     }

//     return communityProfilesArray;
//   };

//   return (
//     <header>
//       <h1>Your {communityName} Profile!</h1>
//       <p>
//         <strong>We use this info to help suggest compatible matches</strong>
//       </p>
//       <p>
//         Profile Status: {isCommunityProfileComplete ? (
//           <span>Complete <span style={{ color: 'green' }}>✓</span></span>
//         ) : (
//           <span><span style={{ color: 'red' }}>✕</span> - please write more in your bio</span>
//         )}
//       </p>
//       {json && json.schemaProfile && json.userProfile && (
//         <div>{renderCommunityProfiles()}</div>
//       )}
//     </header>
//   );
// };

// export default CommunityProfileMain;
